/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiimagedescription2Inputs */

const en_aiimagedescription2 = /** @type {(inputs: Aiimagedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the image and let AI create it.`)
};

const de_aiimagedescription2 = /** @type {(inputs: Aiimagedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibe das Bild und lass die KI es erzeugen.`)
};

/**
* | output |
* | --- |
* | "Describe the image and let AI create it." |
*
* @param {Aiimagedescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiimagedescription2 = /** @type {((inputs?: Aiimagedescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiimagedescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiimagedescription2(inputs)
	return de_aiimagedescription2(inputs)
});
export { aiimagedescription2 as "aiImageDescription" }